export const articlesData = {
  'buy-electricity': {
    title: 'How to buy electricity on Bilm',
    category: 'Electricity',
    categoryColor: 'text-amber-600',
    readTime: '3 min read',
    content: `
      <h2 class="font-heading text-2xl font-bold text-neutral-900 mb-6 flex items-center gap-3">
        <svg class="w-6 h-6 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
        </svg>
        Buying electricity on Bilm is quick and easy
      </h2>
      <p class="text-neutral-700 mb-6">Follow these simple steps to purchase prepaid electricity tokens instantly through the Bilm app.</p>
      
      <div class="space-y-6">
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">1</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Open the Electricity Section</h3>
            <p class="text-neutral-700">Launch the Bilm app and tap on the Electricity icon from your home screen. Your meter number will be pre-filled if you've purchased electricity before.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">2</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Select Your Amount</h3>
            <p class="text-neutral-700">Choose your desired amount from our preset options (₦500, ₦1,000, ₦2,000, ₦5,000, ₦10,000, ₦20,000) or enter a custom amount.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">3</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Confirm and Pay</h3>
            <p class="text-neutral-700">Review your purchase details and confirm the payment. You can pay using bank transfer, card, or USSD.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">4</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Receive Your Token</h3>
            <p class="text-neutral-700">Your electricity token arrives in under 10 seconds. You'll see the 20-digit token displayed on your screen.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">5</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Load Your Token</h3>
            <p class="text-neutral-700">Enter the 20-digit token on your prepaid meter and you're powered up!</p>
          </div>
        </div>
      </div>
      
      <div class="bg-amber-50 border border-amber-200 rounded-large p-4 mt-6">
        <div class="flex items-center gap-2 mb-2">
          <svg class="w-4 h-4 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"></path>
          </svg>
          <h4 class="font-semibold text-amber-800">Pro Tip</h4>
        </div>
        <p class="text-amber-700 text-sm">Enable low balance alerts in Settings to get notified before you run out of electricity units.</p>
      </div>
    `
  },

  'token-not-working': {
    title: 'My electricity token didn\'t work',
    category: 'Electricity',
    categoryColor: 'text-amber-600',
    readTime: '2 min read',
    content: `
      <h2 class="font-heading text-2xl font-bold text-neutral-900 mb-6 flex items-center gap-3">
        <svg class="w-6 h-6 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
        </svg>
        Troubleshooting electricity token issues
      </h2>
      <p class="text-neutral-700 mb-6">If your electricity token doesn't work, don't worry. Follow these steps to resolve the issue quickly.</p>
      
      <div class="space-y-6">
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center shrink-0">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
            </svg>
          </div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Check Token Entry</h3>
            <p class="text-neutral-700">Double-check that you entered all 20 digits correctly. Even one wrong digit will cause the token to fail.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center shrink-0">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"></path>
            </svg>
          </div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Verify Meter Mode</h3>
            <p class="text-neutral-700">Ensure your meter is in "vend" or token entry mode. Some meters need to be in a specific mode to accept tokens.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center shrink-0">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"></path>
            </svg>
          </div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Confirm Meter Number</h3>
            <p class="text-neutral-700">Check that the meter number matches your physical meter. Tokens are meter-specific.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center shrink-0">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.36 6.64a9 9 0 111.41 1.41l-1.41-1.41zm-2.12 4.24a9 9 0 00-1.41-1.41l1.41 1.41z"></path>
            </svg>
          </div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Contact Support</h3>
            <p class="text-neutral-700">If the issue persists, contact Bilm support — we'll reissue a new token within 30 minutes.</p>
          </div>
        </div>
      </div>
      
      <div class="bg-red-50 border border-red-200 rounded-large p-4 mt-6">
        <div class="flex items-center gap-2 mb-2">
          <svg class="w-4 h-4 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"></path>
          </svg>
          <h4 class="font-semibold text-red-800">Common Issues</h4>
        </div>
        <ul class="text-red-700 text-sm space-y-1">
          <li>• Wrong meter number entered</li>
          <li>• Meter not in token entry mode</li>
          <li>• Token already used on another meter</li>
          <li>• Network connectivity issues</li>
        </ul>
      </div>
    `
  },

  'check-balance': {
    title: 'How to check my electricity balance',
    category: 'Electricity',
    categoryColor: 'text-amber-600',
    readTime: '2 min read',
    content: `
      <h2 class="font-heading text-2xl font-bold text-neutral-900 mb-6 flex items-center gap-3">
        <svg class="w-6 h-6 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
        Check your electricity balance easily
      </h2>
      <p class="text-neutral-700 mb-6">Monitor your electricity usage and remaining units to avoid running out unexpectedly.</p>
      
      <div class="space-y-6">
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">1</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Open Electricity Section</h3>
            <p class="text-neutral-700">Tap on the Electricity icon from your home screen to access your electricity dashboard.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">2</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">View Balance Display</h3>
            <p class="text-neutral-700">Your current balance will be prominently displayed at the top of the screen in kWh units.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">3</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Check Usage History</h3>
            <p class="text-neutral-700">Scroll down to see your daily and monthly consumption patterns.</p>
          </div>
        </div>
      </div>
      
      <div class="bg-amber-50 border border-amber-200 rounded-large p-4 mt-6">
        <div class="flex items-center gap-2 mb-2">
          <svg class="w-4 h-4 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <h4 class="font-semibold text-amber-800">Balance Tips</h4>
        </div>
        <ul class="text-amber-700 text-sm space-y-1">
          <li>• Enable low balance alerts at 20% remaining</li>
          <li>• Check balance weekly to track usage</li>
          <li>• Review history to identify consumption patterns</li>
        </ul>
      </div>
    `
  },

  'low-balance-alerts': {
    title: 'Setting up low balance alerts',
    category: 'Electricity',
    categoryColor: 'text-amber-600',
    readTime: '2 min read',
    content: `
      <h2 class="font-heading text-2xl font-bold text-neutral-900 mb-6 flex items-center gap-3">
        <svg class="w-6 h-6 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"></path>
        </svg>
        Never run out of electricity unexpectedly
      </h2>
      <p class="text-neutral-700 mb-6">Set up automatic notifications to alert you when your electricity balance is running low.</p>
      
      <div class="space-y-6">
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">1</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Go to Settings</h3>
            <p class="text-neutral-700">Tap the profile icon and select Settings from the menu.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">2</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Find Notifications</h3>
            <p class="text-neutral-700">Scroll to the Notifications section and tap on Electricity Alerts.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">3</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Set Alert Threshold</h3>
            <p class="text-neutral-700">Choose when to receive alerts - we recommend 20% or 10 kWh remaining.</p>
          </div>
        </div>
      </div>
      
      <div class="bg-amber-50 border border-amber-200 rounded-large p-4 mt-6">
        <div class="flex items-center gap-2 mb-2">
          <svg class="w-4 h-4 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <h4 class="font-semibold text-amber-800">Alert Benefits</h4>
        </div>
        <ul class="text-amber-700 text-sm space-y-1">
          <li>• Receive push notifications on your phone</li>
          <li>• Get SMS alerts for critical levels</li>
          <li>• Email notifications for backup</li>
          <li>• Customizable alert frequencies</li>
        </ul>
      </div>
    `
  },

  'purchase-history': {
    title: 'Viewing electricity purchase history',
    category: 'Electricity',
    categoryColor: 'text-amber-600',
    readTime: '2 min read',
    content: `
      <h2 class="font-heading text-2xl font-bold text-neutral-900 mb-6 flex items-center gap-3">
        <svg class="w-6 h-6 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        Track all your electricity purchases
      </h2>
      <p class="text-neutral-700 mb-6">Access your complete purchase history to track spending and download receipts.</p>
      
      <div class="space-y-6">
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">1</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Open Electricity Section</h3>
            <p class="text-neutral-700">Tap on the Electricity icon from your home screen.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">2</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Tap Purchase History</h3>
            <p class="text-neutral-700">Look for the "Purchase History" button below your current balance.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-amber-100 text-amber-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">3</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">View and Filter</h3>
            <p class="text-neutral-700">Browse all purchases, filter by date range, or search for specific transactions.</p>
          </div>
        </div>
      </div>
      
      <div class="bg-amber-50 border border-amber-200 rounded-large p-4 mt-6">
        <div class="flex items-center gap-2 mb-2">
          <svg class="w-4 h-4 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
          </svg>
          <h4 class="font-semibold text-amber-800">History Features</h4>
        </div>
        <ul class="text-amber-700 text-sm space-y-1">
          <li>• Download PDF receipts for any purchase</li>
          <li>• View token details and meter numbers</li>
          <li>• Export data to Excel or CSV</li>
          <li>• Monthly spending summaries</li>
        </ul>
      </div>
    `
  },

  'disco-support': {
    title: 'Which DISCOs does Bilm support?',
    category: 'Electricity',
    categoryColor: 'text-amber-600',
    readTime: '2 min read',
    content: `
      <h2 class="font-heading text-2xl font-bold text-neutral-900 mb-6 flex items-center gap-3">
        <svg class="w-6 h-6 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
        </svg>
        Supported electricity distribution companies
      </h2>
      <p class="text-neutral-700 mb-6">Bilm supports all major electricity distribution companies (DISCOs) across Nigeria.</p>
      
      <div class="space-y-4">
        <div class="bg-amber-50 border border-amber-200 rounded-large p-4">
          <h3 class="font-semibold text-amber-800 mb-3">Supported DISCOs</h3>
          <div class="grid grid-cols-2 gap-3 text-sm">
            <div class="flex items-center gap-2">
              <div class="w-2 h-2 bg-amber-500 rounded-full"></div>
              <span class="text-amber-700">EKEDC (Eko)</span>
            </div>
            <div class="flex items-center gap-2">
              <div class="w-2 h-2 bg-amber-500 rounded-full"></div>
              <span class="text-amber-700">IKEDC (Ikeja)</span>
            </div>
            <div class="flex items-center gap-2">
              <div class="w-2 h-2 bg-amber-500 rounded-full"></div>
              <span class="text-amber-700">AEDC (Abuja)</span>
            </div>
            <div class="flex items-center gap-2">
              <div class="w-2 h-2 bg-amber-500 rounded-full"></div>
              <span class="text-amber-700">PHEDC (Port Harcourt)</span>
            </div>
            <div class="flex items-center gap-2">
              <div class="w-2 h-2 bg-amber-500 rounded-full"></div>
              <span class="text-amber-700">KEDC (Kano)</span>
            </div>
            <div class="flex items-center gap-2">
              <div class="w-2 h-2 bg-amber-500 rounded-full"></div>
              <span class="text-amber-700">JEDC (Jos)</span>
            </div>
            <div class="flex items-center gap-2">
              <div class="w-2 h-2 bg-amber-500 rounded-full"></div>
              <span class="text-amber-700">BEDC (Benin)</span>
            </div>
            <div class="flex items-center gap-2">
              <div class="w-2 h-2 bg-amber-500 rounded-full"></div>
              <span class="text-amber-700">EEDC (Enugu)</span>
            </div>
          </div>
        </div>
      </div>
      
      <div class="bg-amber-50 border border-amber-200 rounded-large p-4 mt-6">
        <div class="flex items-center gap-2 mb-2">
          <svg class="w-4 h-4 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <h4 class="font-semibold text-amber-800">Need Help?</h4>
        </div>
        <p class="text-amber-700 text-sm">If your DISCO isn't listed, contact support - we're always expanding our coverage!</p>
      </div>
    `
  },

  'autopay': {
    title: 'How to set up autopay',
    category: 'Payments',
    categoryColor: 'text-blue-600',
    readTime: '2 min read',
    content: `
      <h2 class="font-heading text-2xl font-bold text-neutral-900 mb-6 flex items-center gap-3">
        <svg class="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"></path>
        </svg>
        Set up automatic rent payments
      </h2>
      <p class="text-neutral-700 mb-6">Never miss a rent payment again by setting up autopay in the Bilm app.</p>
      
      <div class="space-y-6">
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">1</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Go to Payments Section</h3>
            <p class="text-neutral-700">Open the Bilm app and tap on the Payments tab, then select Autopay from the menu.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">2</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Configure Autopay</h3>
            <p class="text-neutral-700">Set your preferred payment date (1st-30th of each month) and choose your payment method.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">3</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Confirm Details</h3>
            <p class="text-neutral-700">Review the payment amount and schedule, then confirm to activate autopay.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">4</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Receive Confirmation</h3>
            <p class="text-neutral-700">You'll get a confirmation message and your first automatic payment will process on the scheduled date.</p>
          </div>
        </div>
      </div>
      
      <div class="bg-blue-50 border border-blue-200 rounded-large p-4 mt-6">
        <div class="flex items-center gap-2 mb-2">
          <svg class="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <h4 class="font-semibold text-blue-800">Autopay Benefits</h4>
        </div>
        <ul class="text-blue-700 text-sm space-y-1">
          <li>• Never miss a payment deadline</li>
          <li>• Avoid late fees and penalties</li>
          <li>• Get payment reminders 3 days before</li>
          <li>• Modify or cancel anytime</li>
        </ul>
      </div>
    `
  },

  'add-payment': {
    title: 'Adding a payment method',
    category: 'Payments',
    categoryColor: 'text-blue-600',
    readTime: '3 min read',
    content: `
      <h2 class="font-heading text-2xl font-bold text-neutral-900 mb-6 flex items-center gap-3">
        <svg class="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
        </svg>
        Add your payment methods securely
      </h2>
      <p class="text-neutral-700 mb-6">Add bank accounts, cards, or USSD payment methods to make transactions seamless.</p>
      
      <div class="space-y-6">
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">1</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Go to Payment Methods</h3>
            <p class="text-neutral-700">Tap Profile → Payment Methods to manage your payment options.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">2</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Choose Payment Type</h3>
            <p class="text-neutral-700">Select Add Card, Add Bank Account, or Add USSD from the options.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">3</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Enter Details</h3>
            <p class="text-neutral-700">Fill in your payment information securely. All data is encrypted.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">4</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Verify and Save</h3>
            <p class="text-neutral-700">Complete any verification steps and save your payment method.</p>
          </div>
        </div>
      </div>
      
      <div class="bg-blue-50 border border-blue-200 rounded-large p-4 mt-6">
        <div class="flex items-center gap-2 mb-2">
          <svg class="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
          </svg>
          <h4 class="font-semibold text-blue-800">Security Features</h4>
        </div>
        <ul class="text-blue-700 text-sm space-y-1">
          <li>• Bank-level encryption for all data</li>
          <li>• PCI DSS compliant payment processing</li>
          <li>• Two-factor authentication required</li>
          <li>• 24/7 fraud monitoring</li>
        </ul>
      </div>
    `
  },

  'payment-history': {
    title: 'Viewing payment history',
    category: 'Payments',
    categoryColor: 'text-blue-600',
    readTime: '2 min read',
    content: `
      <h2 class="font-heading text-2xl font-bold text-neutral-900 mb-6 flex items-center gap-3">
        <svg class="w-6 h-6 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        Track all your payment transactions
      </h2>
      <p class="text-neutral-700 mb-6">Access your complete payment history to monitor spending and download receipts.</p>
      
      <div class="space-y-6">
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">1</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Open Payments Section</h3>
            <p class="text-neutral-700">Tap on the Payments tab from your home screen.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">2</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Tap Payment History</h3>
            <p class="text-neutral-700">Look for the "Payment History" button at the top of the Payments screen.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">3</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Browse and Filter</h3>
            <p class="text-neutral-700">View all transactions, filter by date, payment type, or search for specific payments.</p>
          </div>
        </div>
      </div>
      
      <div class="bg-blue-50 border border-blue-200 rounded-large p-4 mt-6">
        <div class="flex items-center gap-2 mb-2">
          <svg class="w-4 h-4 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
          </svg>
          <h4 class="font-semibold text-blue-800">History Features</h4>
        </div>
        <ul class="text-blue-700 text-sm space-y-1">
          <li>• Download PDF receipts for any payment</li>
          <li>• Export data to Excel or CSV</li>
          <li>• Monthly and yearly spending reports</li>
          <li>• Search by payment reference</li>
        </ul>
      </div>
    `
  },

  'getting-started': {
    title: 'Getting started with Bilm',
    category: 'Getting Started',
    categoryColor: 'text-green-600',
    readTime: '5 min read',
    content: `
      <h2 class="font-heading text-2xl font-bold text-neutral-900 mb-6 flex items-center gap-3">
        <svg class="w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
        </svg>
        Welcome to Bilm!
      </h2>
      <p class="text-neutral-700 mb-6">Get started with Bilm in just a few simple steps and transform how you manage your home.</p>
      
      <div class="space-y-6">
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">1</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Download the App</h3>
            <p class="text-neutral-700">Download Bilm from the App Store or Google Play. Search for "Bilm - Home Management" and install the app.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">2</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Create Your Account</h3>
            <p class="text-neutral-700">Sign up with your email address and phone number. Verify your phone number to secure your account.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">3</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Add Your Property</h3>
            <p class="text-neutral-700">Enter your property address and unit details. If you're a tenant, you may need an invite code from your landlord.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">4</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Set Up Your Profile</h3>
            <p class="text-neutral-700">Complete your profile by adding personal information and payment methods for seamless transactions.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">5</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Explore Features</h3>
            <p class="text-neutral-700">Start using Bilm's features: pay rent, buy electricity, submit maintenance requests, and connect with your community.</p>
          </div>
        </div>
      </div>
      
      <div class="bg-green-50 border border-green-200 rounded-large p-4 mt-6">
        <div class="flex items-center gap-2 mb-2">
          <svg class="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
          </svg>
          <h4 class="font-semibold text-green-800">Quick Start Tips</h4>
        </div>
        <ul class="text-green-700 text-sm space-y-1">
          <li>• Enable notifications to stay updated</li>
          <li>• Contact your manager to add your electricity meter number</li>
          <li>• Set up autopay for rent payments</li>
          <li>• Join your building's community board</li>
        </ul>
      </div>
    `
  },

  'add-meter': {
    title: 'How to get your meter number added',
    category: 'Getting Started',
    categoryColor: 'text-green-600',
    readTime: '3 min read',
    content: `
      <h2 class="font-heading text-2xl font-bold text-neutral-900 mb-6 flex items-center gap-3">
        <svg class="w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        Get your meter number added
      </h2>
      <p class="text-neutral-700 mb-6">Your property manager will add your meter number to your account during setup.</p>
      
      <div class="space-y-6">
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">1</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Contact Your Manager</h3>
            <p class="text-neutral-700">Reach out to your property manager to have your meter number added to your Bilm account.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">2</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Provide Meter Details</h3>
            <p class="text-neutral-700">Share your meter number and DISCO information with your manager for setup.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">3</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Start Buying Tokens</h3>
            <p class="text-neutral-700">Once added, you can purchase electricity tokens directly through the app.</p>
          </div>
        </div>
      </div>
      
      <div class="bg-green-50 border border-green-200 rounded-large p-4 mt-6">
        <div class="flex items-center gap-2 mb-2">
          <svg class="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <h4 class="font-semibold text-green-800">Important Notes</h4>
        </div>
        <ul class="text-green-700 text-sm space-y-1">
          <li>• Only property managers can add meter numbers</li>
          <li>• Your meter will be verified during setup</li>
          <li>• Contact support if you need assistance</li>
        </ul>
      </div>
    `
  },

  'connect-unit': {
    title: 'Connecting your unit to Bilm',
    category: 'Getting Started',
    categoryColor: 'text-green-600',
    readTime: '3 min read',
    content: `
      <h2 class="font-heading text-2xl font-bold text-neutral-900 mb-6 flex items-center gap-3">
        <svg class="w-6 h-6 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"></path>
        </svg>
        Link your unit to your property
      </h2>
      <p class="text-neutral-700 mb-6">Connect your specific unit to access all building features and services.</p>
      
      <div class="space-y-6">
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">1</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Go to Profile Settings</h3>
            <p class="text-neutral-700">Tap your profile icon and select "My Properties" from the menu.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">2</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Select Your Property</h3>
            <p class="text-neutral-700">Choose the property you want to connect to from your list.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">3</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Enter Unit Details</h3>
            <p class="text-neutral-700">Input your unit number (e.g., "402", "2B", "Block A Flat 3").</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">4</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Request Connection</h3>
            <p class="text-neutral-700">Submit your connection request. Your property manager will approve it.</p>
          </div>
        </div>
      </div>
      
      <div class="bg-green-50 border border-green-200 rounded-large p-4 mt-6">
        <div class="flex items-center gap-2 mb-2">
          <svg class="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <h4 class="font-semibold text-green-800">Connection Benefits</h4>
        </div>
        <ul class="text-green-700 text-sm space-y-1">
          <li>• Access building announcements</li>
          <li>• Connect with neighbors</li>
          <li>• Submit maintenance requests</li>
          <li>• View building-specific services</li>
        </ul>
      </div>
    `
  },

  'submit-maintenance': {
    title: 'How to submit a maintenance request',
    category: 'Maintenance',
    categoryColor: 'text-green-600',
    readTime: '3 min read',
    content: `
      <h2 class="font-heading text-2xl font-bold text-neutral-900 mb-6 flex items-center gap-3">
        <svg class="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
        </svg>
        Submit maintenance requests easily
      </h2>
      <p class="text-neutral-700 mb-6">Report issues and track repairs through the Bilm maintenance system.</p>
      
      <div class="space-y-6">
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">1</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Go to Maintenance</h3>
            <p class="text-neutral-700">Tap the Wrench icon from your home screen to access maintenance.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">2</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Tap New Request</h3>
            <p class="text-neutral-700">Select "Submit New Request" to report a new issue.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">3</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Describe the Issue</h3>
            <p class="text-neutral-700">Select issue type, add description, and upload photos if available.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">4</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Submit Request</h3>
            <p class="text-neutral-700">Review your request and submit. You'll receive a reference number.</p>
          </div>
        </div>
      </div>
      
      <div class="bg-green-50 border border-green-200 rounded-large p-4 mt-6">
        <div class="flex items-center gap-2 mb-2">
          <svg class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <h4 class="font-semibold text-green-800">Request Tips</h4>
        </div>
        <ul class="text-green-700 text-sm space-y-1">
          <li>• Include clear photos of the issue</li>
          <li>• Provide detailed descriptions</li>
          <li>• Specify preferred time for repairs</li>
          <li>• Track status in real-time</li>
        </ul>
      </div>
    `
  },

  'track-maintenance': {
    title: 'Tracking your maintenance request',
    category: 'Maintenance',
    categoryColor: 'text-green-600',
    readTime: '2 min read',
    content: `
      <h2 class="font-heading text-2xl font-bold text-neutral-900 mb-6 flex items-center gap-3">
        <svg class="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path>
        </svg>
        Monitor your repair progress
      </h2>
      <p class="text-neutral-700 mb-6">Stay updated on your maintenance requests from submission to completion.</p>
      
      <div class="space-y-6">
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">1</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Go to Maintenance</h3>
            <p class="text-neutral-700">Tap the Wrench icon and select "My Requests".</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">2</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">View Request Status</h3>
            <p class="text-neutral-700">See all your requests with current status: Submitted, In Progress, or Completed.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-green-100 text-green-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">3</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Track Updates</h3>
            <p class="text-neutral-700">Tap any request to see detailed timeline and contractor updates.</p>
          </div>
        </div>
      </div>
      
      <div class="bg-green-50 border border-green-200 rounded-large p-4 mt-6">
        <div class="flex items-center gap-2 mb-2">
          <svg class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
          </svg>
          <h4 class="font-semibold text-green-800">Status Updates</h4>
        </div>
        <ul class="text-green-700 text-sm space-y-1">
          <li>• Real-time status notifications</li>
          <li>• Contractor assignment updates</li>
          <li>• Estimated completion times</li>
          <li>• Photo updates from repairs</li>
        </ul>
      </div>
    `
  },

  'reset-password': {
    title: 'Resetting your password',
    category: 'Account & Security',
    categoryColor: 'text-purple-600',
    readTime: '2 min read',
    content: `
      <h2 class="font-heading text-2xl font-bold text-neutral-900 mb-6 flex items-center gap-3">
        <svg class="w-6 h-6 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"></path>
        </svg>
        Reset your password securely
      </h2>
      <p class="text-neutral-700 mb-6">Regain access to your account if you've forgotten your password.</p>
      
      <div class="space-y-6">
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">1</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Go to Login Screen</h3>
            <p class="text-neutral-700">Open the app and tap "Forgot Password?" below the login form.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">2</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Enter Email/Phone</h3>
            <p class="text-neutral-700">Input the email address or phone number associated with your account.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">3</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Check Your Messages</h3>
            <p class="text-neutral-700">You'll receive a reset code via SMS or email within 2 minutes.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">4</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Reset Password</h3>
            <p class="text-neutral-700">Enter the reset code and create your new password.</p>
          </div>
        </div>
      </div>
      
      <div class="bg-purple-50 border border-purple-200 rounded-large p-4 mt-6">
        <div class="flex items-center gap-2 mb-2">
          <svg class="w-4 h-4 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path>
          </svg>
          <h4 class="font-semibold text-purple-800">Security Tips</h4>
        </div>
        <ul class="text-purple-700 text-sm space-y-1">
          <li>• Use a strong, unique password</li>
          <li>• Include numbers and special characters</li>
          <li>• Don't reuse passwords from other apps</li>
          <li>• Enable 2FA for extra security</li>
        </ul>
      </div>
    `
  },

  '2fa': {
    title: 'Enabling two-factor authentication',
    category: 'Account & Security',
    categoryColor: 'text-purple-600',
    readTime: '3 min read',
    content: `
      <h2 class="font-heading text-2xl font-bold text-neutral-900 mb-6 flex items-center gap-3">
        <svg class="w-6 h-6 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
        </svg>
        Add an extra layer of security
      </h2>
      <p class="text-neutral-700 mb-6">Protect your account with two-factor authentication (2FA).</p>
      
      <div class="space-y-6">
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">1</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Go to Security Settings</h3>
            <p class="text-neutral-700">Tap Profile → Security → Two-Factor Authentication.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">2</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Choose 2FA Method</h3>
            <p class="text-neutral-700">Select SMS, Email, or Authenticator App for your second factor.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">3</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Set Up Method</h3>
            <p class="text-neutral-700">Follow the setup steps for your chosen 2FA method.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-purple-100 text-purple-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">4</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Verify and Enable</h3>
            <p class="text-neutral-700">Complete the verification and 2FA will be enabled on your account.</p>
          </div>
        </div>
      </div>
      
      <div class="bg-purple-50 border border-purple-200 rounded-large p-4 mt-6">
        <div class="flex items-center gap-2 mb-2">
          <svg class="w-4 h-4 text-purple-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z"></path>
          </svg>
          <h4 class="font-semibold text-purple-800">2FA Benefits</h4>
        </div>
        <ul class="text-purple-700 text-sm space-y-1">
          <li>• Prevents unauthorized access</li>
          <li>• Alerts you to login attempts</li>
          <li>• Works even if password is compromised</li>
          <li>• Multiple backup methods available</li>
        </ul>
      </div>
    `
  },

  'community-board': {
    title: 'Using the community board',
    category: 'Community',
    categoryColor: 'text-indigo-600',
    readTime: '3 min read',
    content: `
      <h2 class="font-heading text-2xl font-bold text-neutral-900 mb-6 flex items-center gap-3">
        <svg class="w-6 h-6 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z"></path>
        </svg>
        Connect with your building community
      </h2>
      <p class="text-neutral-700 mb-6">Stay informed and connected with neighbors through your building's community board.</p>
      
      <div class="space-y-6">
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">1</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Go to Community</h3>
            <p class="text-neutral-700">Tap the Users icon from your home screen to access the community board.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">2</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Browse Posts</h3>
            <p class="text-neutral-700">View announcements, discussions, and events from property management and neighbors.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">3</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Create Posts</h3>
            <p class="text-neutral-700">Share announcements, ask questions, or organize events with your neighbors.</p>
          </div>
        </div>
        
        <div class="flex gap-4">
          <div class="w-8 h-8 bg-indigo-100 text-indigo-600 rounded-full flex items-center justify-center shrink-0 font-bold text-sm">4</div>
          <div class="flex-1">
            <h3 class="font-heading text-lg font-semibold text-neutral-900 mb-2">Interact and Engage</h3>
            <p class="text-neutral-700">Like posts, comment on discussions, and connect with your building community.</p>
          </div>
        </div>
      </div>
      
      <div class="bg-indigo-50 border border-indigo-200 rounded-large p-4 mt-6">
        <div class="flex items-center gap-2 mb-2">
          <svg class="w-4 h-4 text-indigo-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
          </svg>
          <h4 class="font-semibold text-indigo-800">Community Features</h4>
        </div>
        <ul class="text-indigo-700 text-sm space-y-1">
          <li>• Building-wide announcements</li>
          <li>• Neighbor-to-neighbor messaging</li>
          <li>• Event organization and RSVPs</li>
          <li>• Buy/sell/trade marketplace</li>
        </ul>
      </div>
    `
  }
};

export const articlesList = [
  // Popular articles
  { id: 'buy-electricity', title: 'How to buy electricity on Bilm', category: 'electricity', description: 'Step-by-step guide to purchasing prepaid electricity tokens.' },
  { id: 'token-not-working', title: 'My electricity token didn\'t work', category: 'electricity', description: 'Troubleshoot token entry issues and get a replacement.' },
  { id: 'autopay', title: 'How to set up autopay', category: 'payments', description: 'Schedule recurring rent payments automatically.' },
  { id: 'getting-started', title: 'Getting started with Bilm', category: 'getting-started', description: 'Download, set up, and start using Bilm in minutes.' },
  
  // Electricity articles
  { id: 'check-balance', title: 'How to check my electricity balance', category: 'electricity', description: 'Monitor your electricity usage and remaining units.' },
  { id: 'low-balance-alerts', title: 'Setting up low balance alerts', category: 'electricity', description: 'Never run out of electricity unexpectedly with smart alerts.' },
  { id: 'purchase-history', title: 'Viewing electricity purchase history', category: 'electricity', description: 'Track all your electricity purchases and download receipts.' },
  { id: 'disco-support', title: 'Which DISCOs does Bilm support?', category: 'electricity', description: 'See all supported electricity distribution companies.' },
  
  // Payment articles
  { id: 'add-payment', title: 'Adding a payment method', category: 'payments', description: 'Add bank accounts, cards, or USSD for seamless payments.' },
  { id: 'payment-history', title: 'Viewing payment history', category: 'payments', description: 'Access complete payment history and download receipts.' },
  
  // Getting Started articles
  { id: 'add-meter', title: 'How to get your meter number added', category: 'getting-started', description: 'Contact your property manager to add your meter number.' },
  { id: 'connect-unit', title: 'Connecting your unit to Bilm', category: 'getting-started', description: 'Link your unit to access building features and services.' },
  
  // Maintenance articles
  { id: 'submit-maintenance', title: 'How to submit a maintenance request', category: 'maintenance', description: 'Report issues and track repairs through Bilm.' },
  { id: 'track-maintenance', title: 'Tracking your maintenance request', category: 'maintenance', description: 'Monitor your repair progress in real-time.' },
  
  // Account & Security articles
  { id: 'reset-password', title: 'Resetting your password', category: 'account', description: 'Regain access to your account securely.' },
  { id: '2fa', title: 'Enabling two-factor authentication', category: 'account', description: 'Add an extra layer of security to your account.' },
  
  // Community articles
  { id: 'community-board', title: 'Using the community board', category: 'community', description: 'Connect with neighbors and stay informed.' }
];

export const getArticle = (articleId) => {
  return articlesData[articleId] || null;
};

export const getArticlesByCategory = (category) => {
  if (category === 'all') return articlesList;
  return articlesList.filter(article => article.category === category);
};
